import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeApp } from "./lib/init";

// Initialize app (handle redirects, session cleanup) before rendering
initializeApp().then((shouldRender) => {
  if (shouldRender) {
    createRoot(document.getElementById("root")!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  }
});
